import { Box, Grid } from '@mui/joy'
import Image from 'next/image'
import AspectRatio from '@mui/joy/AspectRatio'
import Section from '../../Section/Section'
import { Text } from '../../Text'

export default function Benefits({ title, description, heroImage }) {
    return (
        <Section bg="#e3eff6">
            <Box>
                <Text textAlign="center" fontSize="2rem" color="#0d417d">
                    {title}
                </Text>
                <Grid container alignItems="center" spacing={15}>
                    <Grid xs={12} sm={6} md={6} lg={6}>
                        <Box position="relative" height="100%" width="100%">
                            <AspectRatio ratio="1 / 1">
                                <Image
                                    quality={80}
                                    fill
                                    src={heroImage?.url}
                                    alt={heroImage?.alt}
                                    style={{
                                        objectFit: 'cover',
                                    }}
                                />
                            </AspectRatio>
                        </Box>
                    </Grid>
                    <Grid xs={12} sm={6} md={6} lg={6}>
                        <Text
                            sx={{
                                whiteSpace: 'pre-line',
                            }}
                        >{`${description}`}</Text>
                        {/* <Stack spacing={4}>
                            <Text>
                                A term loan can be a good option for businesses
                                that need to purchase new assets or equipment.
                                The opportunity to grow your operations and the
                                revenue you earn will help you pay back the
                                loan.
                            </Text>
                            <Text>
                                Term loans are a great option for businesses
                                that need short-term financing. They offer low
                                rates and flexible repayment terms, which can
                                make it easier for your business to get the
                                money it needs without becoming too burdened.
                            </Text>
                            <Text>
                                A term loan can be a great way to build your
                                small business credit. By making your payments
                                on time, you can show lenders that you are a
                                responsible borrower and increase your chances
                                of being approved for future loans.
                            </Text>
                        </Stack> */}
                    </Grid>
                </Grid>
            </Box>
        </Section>
    )
}
